<template>
  <div class="d-flex flex-wrap mb-4">
    <template v-for="room in rooms">
      <div
        v-if="room.room.state != 'processing'"
        :key="room.task_id"
        class="room mr-4 mb-4"
        :class="{'room--empty': room.room.state=='empty'}"
      >
        <p
          v-if="room.room.state=='empty'"
          class="empty-text"
        >
          {{ $t('autocaller_v2.monitoring.rooms.empty') }}
        </p>
        <badge-status :state="room.room.state+'-room'" class="col-6 room-state">
          {{ $t(`autocaller_v2.monitoring.rooms.state.${room.room.state}`) }}
        </badge-status>
        <div class="room--info">
          <p>{{ room.login }}</p>
          <p v-if="room.number">+{{ room.number }}</p>
          <p class="col-12 pl-0 pr-0">
            <i-progress
              v-if="room.room.state == 'pending' || room.room.state == 'busy'"
              :percent="room.room.duration/4" :stroke-width="16"
              stroke-color="#DBF3FF"
              status="active"
              class="mb-3"
            >
              <p class="minutes">{{getMinutes(room.room.state_changed_at, 'busy')}}</p>
            </i-progress>
            <i-progress
              v-if="room.room.state == 'pending'"
              :percent="(Date.now().toString().slice(0,-3) - room.room.state_changed_at)/4"
              :stroke-width="16"
              stroke-color="#FBB3B3"
              status="active"
              class="mb-2"
            >
              <p class="minutes">{{getMinutes(room.room.state_changed_at, 'pending')}}</p>
            </i-progress>
          </p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import BadgeStatus from './monitoring-badge-status';
  import Duration from './monitoring-duration';
  import { seconds_to_time } from '@shared/helpers/time';
  export default {
    components: {
      BadgeStatus,
      Duration
    },
    props: {
      rooms: {
        type: [Object, Array, String],
        default: () => {}
      }
    },
    data() {
      return {
        minutes: {
          pending : null,
          busy: null
        }
      }
    },
    methods: {
      getMinutes(sec, status) {
        let date = parseInt(Date.now().toString().slice(0,-3));
        if( status == 'pending') {
          this.minutes.pending = sec
        }
        if( !this.minutes.busy && status == 'busy') {
          this.minutes.busy = sec
        }
        return status == 'pending' ? seconds_to_time(date - this.minutes.pending) : seconds_to_time(date - this.minutes.busy)
      }
    }
  }
</script>

<style lang="scss">
  .room {
    width: calc(25% - 1.5rem);
    border: 1px solid $border-pending;
    border-radius: 0px 6px 6px 6px;
    .minutes {
      position: absolute;
      left: 10px;
      top: 1px;
    }
    .ivu-progress-outer {
      padding-right: 0;
    }
    &:nth-child(4n) {
      margin-right: 0;
    }
    &--info {
      min-height: 150px;
      padding: 1rem 1rem 0rem 1rem;
      font-size: 16px;
    }
    &--empty {
      position: relative;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        display: block;
        width: 99%;
        height: 99%;
        background: rgba(244, 244, 244, 0.95);
        filter: blur(10px);
      }
    }
  }
  .empty-text{
    position: absolute;
    z-index: 9;
    /* top: 50%; */
    /* left: 50%; */
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    height: 100%;
    width: 100%;
  }
  .duration {
    position: absolute;
    left: 10px;
    top: 1px;
    color: #000;
  }
</style>
